import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

interface FadeInProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  /** How far below the resting position to start (px). Negative = above. */
  y?: number;
  duration?: number;
  /**
   * Kept for API compatibility — every FadeIn now animates on mount. The
   * previous `whileInView` behaviour broke automated screenshots and SSR
   * crawlers because the IntersectionObserver wouldn't fire for content
   * below the fold.
   */
  immediate?: boolean;
}

export function FadeIn({
  children,
  className,
  delay = 0,
  y = 12,
  duration = 0.45,
}: FadeInProps) {
  const reduce = useReducedMotion();
  const initial = reduce ? { opacity: 1, y: 0 } : { opacity: 0, y };
  const animate = { opacity: 1, y: 0 };
  const transition = { duration, delay, ease: [0.16, 1, 0.3, 1] as const };

  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
}
